import * as React from "react";

const SvgIcnPlay = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 11 14" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M1.588.155l8.3 6.036a1 1 0 010 1.618l-8.3 6.036A1 1 0 010 13.036V.964A1 1 0 011.588.155z"
        />
    </svg>
);

export default SvgIcnPlay;
